<ng-container *ngFor="let alert of alertNotifications">
  <div class="alert alert-{{ alert.type.toString().toLowerCase() }}" role="alert">{{ alert.message }}</div>
</ng-container>
